export const searchDebounceTime = 1_000;
export const autocompleteDebounceTime = 300;

export const autocompleteFilterDebounceTime = 150;
